import cTitle from './title.vue'

export { cTitle }
